exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".addhead[data-v-6309fb5c]{margin-top:20px;margin-right:20px}.addhead ul[data-v-6309fb5c]{padding-right:20px}.addhead ul li[data-v-6309fb5c]{width:100%}.addhead .video[data-v-6309fb5c]{width:300px;height:300px}.addhead .upload-wrapper[data-v-6309fb5c]{position:relative;margin-right:15px}.addhead .upload-wrapper .upload-file-cn[data-v-6309fb5c]{position:absolute;height:33px;opacity:0;border:none}.addhead .upload-wrapper .upload-file-en[data-v-6309fb5c]{position:absolute;height:33px;opacity:0;border:none}.addhead .upload-wrapper .upload-file-ja[data-v-6309fb5c]{position:absolute;height:33px;opacity:0;border:none}\n", ""]);

// exports
